import { TabItem } from "@atoms"

import { TabStack } from "@molecules"

import {
    JobTimelineScheduler,
    TimelineViewTimeFrames,
} from "@pages/Jobs/JobList/views/JobTimelineView/JobTimelineView.types"
import useJobTimelineViewBryntumInstances from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewBryntumInstances"
import useJobTimelineViewData from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewData"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

const timeFrameOptions: { value: TimelineViewTimeFrames; label: string }[] = [
    { value: "day", label: "Day" },
    { value: "threeDays", label: "3 days" },
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
]

export default function TimelineViewTimeFrameSelector() {
    const { timeFrameType, setTimeFrameType } = useJobTimelineViewStates()
    const { schedulerPro } = useJobTimelineViewBryntumInstances()
    const { addResourceTimeRangesToScheduler, narrowDateRangeToCenterDate } = useJobTimelineViewData()

    const onSelect = (value: TimelineViewTimeFrames) => {
        const schedulerInstance = schedulerPro.current?.instance as JobTimelineScheduler
        if (schedulerInstance) {
            schedulerInstance.infiniteScroll = false
            schedulerInstance.resourceColumns?.refresh()
        }

        if (value === "day") {
            addResourceTimeRangesToScheduler()
        }

        narrowDateRangeToCenterDate()
        setTimeFrameType(value)
    }

    return (
        <TabStack variant="contained" size="lg" isFullWidth={true}>
            {timeFrameOptions.map((option) => (
                <TabItem
                    key={option.value}
                    isSelected={timeFrameType === option.value}
                    onClick={() => onSelect(option.value)}
                    noDebounce={true}
                >
                    {option.label}
                </TabItem>
            ))}
        </TabStack>
    )
}
